<script setup>
import ModalBox from './ModalBox.vue'
import FormButton from '../Atoms/FormButton.vue'

// Props
const props = defineProps({
	title: {
		type: String,
	},
	body: {
		type: String,
	},
	onAction: {
		type: Function,
		required: false,
		default: undefined,
	},
	// Example with custom validator
	onSubmit: {
		type: Function,
		required: false,
		default: () => Promise.resolve(),
	},
	onCancel: {
		type: Function,
		required: false,
		default: () => Promise.resolve(),
	},
	hideConfirm: {
		type: Boolean,
		default: false
	},
	hideCancel: {
		type: Boolean,
		default: false
	},
	confirmText: {
		type: String,
		default: 'Confirm'
	},
	cancelText: {
		type: String,
		default: 'Cancel'
	},
	scrollBody: {
		type: Boolean,
		default: true
	}
})

// Model
const isVisible = defineModel('isVisible')

//Methods
const confirm = () => {
	isVisible.value = false
	props.onSubmit()
}

const cancel = () => {
	isVisible.value = false
	props.onCancel()
}
</script>

<template>
	<ModalBox v-model="isVisible" :title="props.title" size="sm" :scroll-body="scrollBody">
		<template #header>
			<slot name="header" />
		</template>
		<div class="px-4 pb-4 text-sm text-surface-9 sm:px-6 sm:pb-6">
			<slot />
			{{ props.body }}
		</div>
		<template #footer v-if="!props.hideCancel || !props.hideConfirm">
			<footer class="flex flex-col gap-2 border-t border-surface-3 p-4 sm:flex-row-reverse sm:p-6">
				<FormButton v-if="!props.hideConfirm" class="w-full justify-center sm:w-auto" @click="confirm">
					{{ props.confirmText }}
				</FormButton>
				<FormButton v-if="!props.hideCancel" class="w-full justify-center sm:w-auto" type="secondary" @click="cancel">
					{{ props.cancelText }}
				</FormButton>
			</footer>
		</template>
	</ModalBox>
</template>

<style></style>